import { ReactElement, MouseEvent, ReactNode } from 'react'
import BaseModal from '../BaseModal'

import { H4 } from 'components/Typography'
import { CommonButton } from 'components/Button'
import { ButtonVariants } from 'components/Button/CommonButton'
import { ModalProps } from '../types'

import {
  ConfirmModalInner,
  ConfirmModalTitle,
  ConfirmModalBody,
  ConfirmModalFooter,
} from './styles'

interface ConfirmModalProps extends ModalProps {
  icon?: ReactElement
  title: ReactNode
  children?: ReactNode
  discardBtnTitle?: ReactNode
  confirmBtnTitle?: ReactNode
  onDiscard?: (ev: MouseEvent<HTMLElement>) => void
  onConfirm?: (ev: MouseEvent<HTMLElement>) => void
  variant?: ButtonVariants
  isConfirmBtnDisabled?: boolean
}

function ConfirmModal({
  isOpen,
  icon,
  title,
  children,
  discardBtnTitle,
  confirmBtnTitle,
  isConfirmBtnDisabled,
  onDiscard,
  onConfirm,
  onRequestClose = onDiscard,
  variant,
}: ConfirmModalProps) {
  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose}>
      <ConfirmModalInner>
        {icon}

        <ConfirmModalTitle>
          <H4>{title}</H4>
        </ConfirmModalTitle>

        <ConfirmModalBody>{children}</ConfirmModalBody>

        <ConfirmModalFooter>
          <CommonButton variant="secondary" onClick={onDiscard}>
            {discardBtnTitle}
          </CommonButton>
          <CommonButton
            variant={variant}
            onClick={onConfirm}
            disabled={isConfirmBtnDisabled}
          >
            {confirmBtnTitle}
          </CommonButton>
        </ConfirmModalFooter>
      </ConfirmModalInner>
    </BaseModal>
  )
}

export default ConfirmModal
